import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=33053e41&scoped=true&"
import script from "./VideoComponent.vue?vue&type=script&lang=ts&"
export * from "./VideoComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=33053e41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33053e41",
  null
  
)

export default component.exports